export default __webpack_public_path__ + "static/media/bag5.66db8110.jfif";